module.exports = __webpack_public_path__ + "img/제품수요파악아이콘.51987dc4.png";